import React, { useState } from 'react'
import './SalesBizForm.scss'

import useMailing from '../../hooks/useMailing'

import salesBiz_valid from '../../hooks/useValid/salesBiz_valid'
import useValid from '../../hooks/useValid'

import Button from '../../components/Button'
import DeliveryStatus from '../../components/DeliveryStatus'
import RadioList from '../../components/RadioList'
import Select from '../../components/Select'

import { ReactComponent as IqonDanger } from '../../assets/iqons/iqon_danger_stroke.svg'


const SalesBizContactForm = () => {

    const [initialState] = useState({
        business_name: '',
        business_size: '',
        business_size_text: '',
        comments: '',
        contact_channel: 'call',
        contact_channel_text: 'Llamada',
        country: '',
        email: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        sales_interests: []
    })
    const [contactChannel] = useState([
        {
            text: 'Llamada',
            value: 'call'
        },
        {
            text: 'Email',
            value: 'email'
        },
        {
            text: 'WhatsApp',
            value: 'whatsapp'
        }
    ])
    const [businessSize] = useState([
        {
            text: '1 a 99',
            value: 99
        },
        {
            text: '100 a 499',
            value: 499
        },
        {
            text: '500 a 999',
            value: 999
        },
        {
            text: '1,000 a 4,999',
            value: 4999
        },
        {
            text: '5,000 a 9,999',
            value: 9999
        },
        {
            text: '10,000 o más',
            value: 10000
        }
    ])
    const [salesBizInterests] = useState([
        {
            text: '¿Cómo empiezo a usar Qibo?',
            value: 'letsStart'
        },
        {
            text: 'La tecnología de Qibo',
            value: 'qiboTechnology'
        },
        {
            text: 'Evaluar al personal',
            value: 'evaluation'
        },
        {
            text: 'Entrevistas para contratación',
            value: 'recruitment'
        },
        {
            text: 'Call center',
            value: 'callCenter'
        },
        {
            text: 'Auditoría interna',
            value: 'audit'
        },
        {
            text: 'Detección de quebrantadores',
            value: 'investigation'
        },
        {
            text: 'Equipo directivo',
            value: 'executives'
        },
        {
            text: 'Administrativos en general',
            value: 'inGeneral'
        },
        {
            text: 'Logística',
            value: 'logística'
        },
        {
            text: 'Seguridad',
            value: 'security'
        },
        {
            text: 'Hospitalidad',
            value: 'hospitality'
        },
        {
            text: 'Restaurantes',
            value: 'restaurants'
        },
        {
            text: 'Cadena de producción',
            value: 'productionChain'
        },
        {
            text: 'Empeño y valores',
            value: 'pawn'
        },
        {
            text: 'Banca',
            value: 'bank'
        },
        {
            text: 'Otro tema',
            value: 'other'
        }
    ])

    const [delivery, setDelivery] = useState(null)

    const { formData, forceTouch, handleBlur, handleChange } = useValid(initialState, salesBiz_valid)
    const { contactBizRep } = useMailing()

    const input_data = formData.input_data
    const errors = formData.errors_data
    const touched = formData.touched_fields
    const valid = formData.validation.may_submit

    const delivered = delivery && delivery.delivery && delivery.delivery.state === 'SUCCESS'
    const undelivered = delivery && delivery.delivery && delivery.delivery.state === 'ERROR'

    const handleChannelPlaceholder = () => {
        if (input_data.contact_channel === 'call') return 'Teléfono o celular *'
        else if (input_data.contact_channel === 'email') return 'Email *'
        else if (input_data.contact_channel === 'whatsapp') return 'Celular *'
    }

    const handleSubmit = e => {
        e.preventDefault()
        if (!valid) {
            console.log(errors)
            forceTouch('business_name')
            forceTouch('business_size')
            forceTouch('country')
            forceTouch('email')
            forceTouch('first_name')
            forceTouch('last_name')
            forceTouch('phone_number')
            forceTouch('sales_interests')
        }
        else if (valid) {
            setDelivery(true)
            window.scrollTo(0, 0)
            contactBizRep(
                input_data.business_name,
                input_data.business_size_text,
                input_data.comments,
                input_data.contact_channel_text,
                input_data.country,
                input_data.email,
                input_data.first_name,
                input_data.last_name,
                input_data.phone_number,
                input_data.sales_interests,
            ).then( r => {
                r.onSnapshot( snapshot => {
                    console.log('mail', snapshot.data())
                    setDelivery(snapshot.data())
                })
            })
        }
    }

    const formRender = () =>
        <form onSubmit={handleSubmit} className="row c12 SalesBizForm__container p00">
            <div className="row c06 SalesBizForm__field--container py10">
                <input
                    className={`
                        ${!errors.first_name && touched.first_name && 'success'}
                        ${errors.first_name && touched.first_name && 'error'}
                    `}
                    name="first_name"
                    type="text"
                    placeholder="Nombre *"
                    value={input_data.first_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.first_name && touched.first_name && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.first_name}
                </span>}
            </div>
            <div className="row c06 SalesBizForm__field--container py10">
                <input
                    className={`
                        ${!errors.last_name && touched.last_name && 'success'}
                        ${errors.last_name && touched.last_name && 'error'}
                    `}
                    name="last_name"
                    type="text"
                    placeholder="Apellido *"
                    value={input_data.last_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.last_name && touched.last_name && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.last_name}
                </span>}
            </div>
            <div className="column c12 SalesBizForm__field--container pt10 pb05 px30">
                <p className="SalesBizForm__label">¿Cómo quieres que te contactemos?</p>
            </div>
            <div className="row c04s SalesBizForm__field--container py10">
                <Select
                    activeValue={input_data.contact_channel_text}
                    placeOption="Contacto *"
                    height="200px"
                    slice={20}
                >
                    {contactChannel.map( (i, idx) =>
                        <span
                            className={`${input_data.contact_channel === i.value ? 'active' : null}`}
                            inside="true"
                            key={idx}
                            onClick={() => {
                                handleChange({target: {
                                    name: 'contact_channel',
                                    value: i.value
                                }})
                                handleChange({target: {
                                    name: 'contact_channel_text',
                                    value: i.text
                                }})
                                setTimeout( () => {
                                    forceTouch('role')
                                }, 50)
                            }}
                        >
                            {i.text}
                        </span>
                    )}
                </Select>
            </div>
            <div className="row c08s SalesBizForm__field--container py10">
                <input
                    className={`
                        ${['call', 'whatsapp'].includes(input_data.contact_channel)
                            && !errors.phone_number && touched.phone_number && 'success'}
                        ${input_data.contact_channel === 'email'
                            && !errors.email && touched.email && 'success'}
                        ${['call', 'whatsapp'].includes(input_data.contact_channel)
                            && errors.phone_number && touched.phone_number && 'error'}
                        ${input_data.contact_channel === 'email'
                            && errors.email && touched.email && 'error'}
                    `}
                    name={input_data.contact_channel === 'email' ? 'email' : 'phone_number'}
                    type={input_data.contact_channel === 'email' ? 'email' : 'number'}
                    placeholder={handleChannelPlaceholder()}
                    value={input_data.contact_channel === 'email' ? input_data.email : input_data.phone_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {['call', 'whatsapp'].includes(input_data.contact_channel)
                    && errors.phone_number && touched.phone_number && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.phone_number}
                </span>}
                {input_data.contact_channel === 'email'
                    && errors.email && touched.email && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.email}
                </span>}
            </div>
            <div className="row c12 SalesBizForm__field--container py10">
                <input
                    className={`
                        ${!errors.business_name && touched.business_name && 'success'}
                        ${errors.business_name && touched.business_name && 'error'}
                    `}
                    name="business_name"
                    type="text"
                    placeholder="Nombre de la empresa *"
                    value={input_data.business_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.business_name && touched.business_name && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.business_name}
                </span>}
            </div>
            <div className="row c08s SalesBizForm__field--container py10">
                <Select
                    activeValue={input_data.business_size_text}
                    placeOption="Tamaño de la empresa *"
                    height="200px"
                    slice={20}
                    success={!errors.business_size && touched.business_size}
                    error={errors.business_size && touched.business_size}
                >
                    {businessSize.map( (i, idx) =>
                        <span
                            className={`${input_data.role === i.value ? 'active' : null}`}
                            inside="true"
                            key={idx}
                            onClick={() => {
                                handleChange({target: {
                                    name: 'business_size',
                                    value: i.value
                                }})
                                handleChange({target: {
                                    name: 'business_size_text',
                                    value: i.text
                                }})
                                setTimeout( () => {
                                    forceTouch('business_size')
                                }, 50)
                            }}
                        >
                            {i.text}
                        </span>
                    )}
                </Select>
                {errors.business_size && touched.business_size && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.business_size}
                </span>}
            </div>
            <div className="row c04s SalesBizForm__field--container py10">
                <input
                    className={`
                        ${!errors.country && touched.country && 'success'}
                        ${errors.country && touched.country && 'error'}
                    `}
                    name="country"
                    type="text"
                    placeholder="País *"
                    value={input_data.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.country && touched.country && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.country}
                </span>}
            </div>
            <div className={`column c12 SalesBizForm__field--container pt10 pb05 px30
                ${errors.sales_interests && touched.sales_interests && 'error'}
            `}>
                <p className="SalesBizForm__label">¿Sobre qué temas quieres información? *</p>
                {(!errors.sales_interests || !touched.sales_interests) && <p className="SalesBizForm__hint">Puedes elegir más de uno</p>}
                {errors.sales_interests && touched.sales_interests && <span className="error p00 mt05">
                    <IqonDanger className="error" />
                    {errors.sales_interests}
                </span>}
            </div>
            <div className="row c12 SalesBizForm__field--container py10">
                <RadioList
                    items={salesBizInterests}
                    activeValue={input_data.sales_interests}
                    handleUpdate={ u => {
                        handleChange({target: {
                            name: 'sales_interests',
                            value: u
                        }})
                        setTimeout( () => {
                            forceTouch('sales_interests')
                        }, 50)
                    }}
                />
            </div>
            <div className="row c12 SalesBizForm__field--container py10">
                <textarea
                    className={`
                        ${!errors.comments && touched.comments && 'success'}
                        ${errors.comments && touched.comments && 'error'}
                    `}
                    name="comments"
                    rows="3"
                    placeholder="¿Algo más que quieras agregar? (opcional)"
                    value={input_data.comments}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
            </div>
            <div className="row c12 SalesBizForm__field--container py10">
                <Button
                    css={`btn ${valid ? 'btn--grow' : 'btn--disabled'} mlAuto`}
                    inlineStyle={{fontWeight: 800}}
                    type="submit"
                >
                    Enviar
                </Button>
            </div>
        </form>

    return (<>
        {!delivery ? formRender() : <DeliveryStatus error={undelivered} success={delivered} />}
    </>)
}

export default SalesBizContactForm
